const CACHE_VERSION = "v1";
export const MODULE_CACHE_TTL = 5 * 60 * 1000;

function safeParse(value, fallback = null) {
  if (!value) return fallback;
  try {
    return JSON.parse(value);
  } catch (error) {
    console.warn("Invalid localStorage JSON", error);
    return fallback;
  }
}

function getUserScope() {
  const user = safeParse(localStorage.getItem("user"), {});
  const userId = user?.data?.id ?? user?.id ?? "guest";
  const organizationId =
    localStorage.getItem("organization_id") ||
    user?.data?.organization_id ||
    user?.data?.org_id ||
    "default";
  return `${userId}:${organizationId}`;
}

function modulePrefix(moduleName) {
  return `promxa:${CACHE_VERSION}:${getUserScope()}:${moduleName}`;
}

export function readJSON(key, fallback = null) {
  return safeParse(localStorage.getItem(key), fallback);
}

export function writeJSON(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
    return true;
  } catch (error) {
    console.warn("Unable to write localStorage", error);
    return false;
  }
}

export function getModuleSelection(moduleName, fallback = null) {
  return readJSON(`${modulePrefix(moduleName)}:selection`, fallback);
}

export function setModuleSelection(moduleName, selection) {
  return writeJSON(`${modulePrefix(moduleName)}:selection`, selection);
}

export function clearModuleSelection(moduleName) {
  localStorage.removeItem(`${modulePrefix(moduleName)}:selection`);
}

function stableValue(value) {
  if (Array.isArray(value)) return value.map(stableValue);
  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((result, key) => {
        if (value[key] !== undefined) result[key] = stableValue(value[key]);
        return result;
      }, {});
  }
  return value;
}

export function createCacheKey(value) {
  return JSON.stringify(stableValue(value));
}

export function getModuleCache(moduleName, requestKey) {
  const entry = readJSON(`${modulePrefix(moduleName)}:cache`, null);
  if (!entry || entry.requestKey !== requestKey || !entry.timestamp) return null;
  return {
    data: entry.data,
    timestamp: entry.timestamp,
    isFresh: Date.now() - entry.timestamp <= MODULE_CACHE_TTL,
  };
}

export function setModuleCache(moduleName, requestKey, data) {
  return writeJSON(`${modulePrefix(moduleName)}:cache`, {
    requestKey,
    timestamp: Date.now(),
    data,
  });
}

export function clearModuleCache(moduleName) {
  localStorage.removeItem(`${modulePrefix(moduleName)}:cache`);
}
